// extracted by mini-css-extract-plugin
export default {"companyContainer":"rN-z","companyImage":"sN-z","container":"tN-z","heading":"uN-z","darkText":"vN-z","smallHeading":"wN-z","darkBackground":"xN-z","whiteBackground":"yN-z"};